export const getStyle = (el, styleName, toInt = false) => {
  if (el) {
    let style = el.currentStyle ? el.currentStyle : window.getComputedStyle(el, null)
    let value = styleName ? style.getPropertyValue(styleName) || null : style
    return toInt ? parseInt(value) : value
  }
  return null
}

export const setStyle = (el, styleName, value) => {
  if (el && styleName) {
    if (typeof styleName == 'object') {
      for (let key in styleName) {
        setStyle(el, key, styleName[key])
      }
    } else {
      el.style[styleName] = value
    }
  }
}

export const getClass = (el) => {
  if (el) {
    let {className = ''} = el
    return className.split(' ')
  }
  return []
}

export const addClass = (el, className) => {
  if (el) {
    let currentClass = el.className.split(' ')
    if (!currentClass.includes(className)) {
      currentClass.push(className)
    }
    el.className = currentClass.join(' ').trim()
  }
}

export const removeClass = (el, className) => {
  if (el) {
    let currentClass = el.className.split(' ')
    el.className = currentClass.filter(cls => cls != className).join(' ').trim()
  }
}

export const getMousePosOnElement = (e) => {
  let rect = e.target.getBoundingClientRect()
  return {left: e.clientX - rect.left, top: e.clientY - rect.top}
}
